// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @ utils
const { formatText } = require('core/i18n').i18n;

// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');

const InsuranceRequestPlansApplyButton = (
    plan,
    column,
    immInsuranceWizardStep,
    isColumnDisabled,
    handleHoverColumn,
    handleClickSelectPlan,
    isRelated,
    onhandleChangeSelectedPlanInStateComponent
) => {
    const buttonsDisabled = isColumnDisabled(column);
    const isLoading = immInsuranceWizardStep.get('isFetchingSelectPlan');
    const selectedPlan = immInsuranceWizardStep.get('insurancePlan');
    let buttonContent = formatText('insuranceRequestHome-step3ApplyFor');

    if (selectedPlan === plan) {
        buttonContent = <span className="coverage-and-plans__checkmark"></span>;
    }
    const clickCallBack = isRelated ?
        () => {
            handleClickSelectPlan(plan);
            onhandleChangeSelectedPlanInStateComponent(plan);
        } :
        (evt) => handleClickSelectPlan(evt, plan)
    return (
        <td
            key={column}
            className="coverage-and-plans__table-cell coverage-and-plans__table-cell--button"
            onMouseEnter={handleHoverColumn}
        >
            <OKButton
                modifier="secondary"
                block={true}
                onClick={clickCallBack}
                disabled={buttonsDisabled}
                loading={isLoading}
            >
                {buttonContent}
            </OKButton>
        </td>
    );
};

InsuranceRequestPlansApplyButton.propTypes = {
    plan: PropTypes.string.isRequired,
    column: PropTypes.number.isRequired,
    immInsuranceWizardStep: PropTypes.object.isRequired,
    isColumnDisabled: PropTypes.func.isRequired,
    handleHoverColumn: PropTypes.func.isRequired,
    handleClickSelectPlan: PropTypes.func.isRequired,
};


module.exports = InsuranceRequestPlansApplyButton;
